<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--引导块-->
			<div
				v-if="infoData"
				class="tips_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tips_main">
					<span>Home&nbsp;&nbsp;>&nbsp;&nbsp;Products&nbsp;&nbsp;>&nbsp;&nbsp;{{ infoData.parent_name }}&nbsp;&nbsp;>&nbsp;&nbsp;</span>{{ infoData.title }}
				</div>
			</div>
			<!--引导块-->
			<!--banner-->
			<div v-if="infoData" class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/FSH/1.webp" />
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_1_main">
					<div class="product_el mar_r">
						<div class="tips">Ref #: ACT21048-25</div>
						<van-image
							width="100%"
							height="auto"
							:src="require('@/assets/FSH/2.webp')"
						/>
						<div class="tit">FSH Strip</div>
						<div class="txt">Package Size</div>
						<div class="tag_box">
							<div class="tag_el mar_r active">25 Tests</div>
						</div>
						<div class="txt_box">
							<div class="txt_el">
								● 25 Follicle-Stimulating Hormone<br />
								&ensp; (FSH) Test Strips
							</div>
							<div class="txt_el">
								● 25 Urine Cups
							</div>
							<div class="txt_el">
								● 1 Instructions for Use
							</div>
						</div>
						<div class="btn_box">
							<van-button class="btn" type="primary" color="#EF709E" block style="height: 72px;border-radius: 16px;" @click="goBuy(1)">Buy Now</van-button>
						</div>
					</div>
					<div class="product_el">
						<div class="tips">Ref #: ACT21049-10</div>
						<van-image
							width="100%"
							height="auto"
							:src="require('@/assets/FSH/3.webp')"
						/>
						<div class="tit">FSH Cassette</div>
						<div class="txt">Package Size</div>
						<div class="tag_box">
							<div class="tag_el mar_r active">10 Tests</div>
						</div>
						<div class="txt_box">
							<div class="txt_el">
								● 10 Follicle-Stimulating Hormone<br />
								&ensp; (FSH) Test Cassettes
							</div>
							<div class="txt_el">
								● 10 Urine Cups
							</div>
							<div class="txt_el">
								● 10 Droppers
							</div>
							<div class="txt_el">
								● 1 Instructions for Use
							</div>
						</div>
						<div class="btn_box">
							<van-button class="btn" type="primary" color="#EF709E" block style="height: 72px;border-radius: 16px;" @click="goBuy(2)">Buy Now</van-button>
						</div>
					</div>
					<div class="product_el mar_l">
						<div class="tips">Ref #: ACT21050-3</div>
						<van-image
							width="100%"
							height="auto"
							:src="require('@/assets/FSH/4.webp')"
						/>
						<div class="tit">COT Midstream</div>
						<div class="txt">Package Size</div>
						<div class="tag_box">
							<div class="tag_el mar_r active">3 Tests</div>
						</div>
						<div class="txt_box">
							<div class="txt_el">
								● 3 Follicle-Stimulating Hormone<br />
								&ensp; (FSH) Test Midstream
							</div>
							<div class="txt_el">
								● 1 Instructions for Use
							</div>
						</div>
						<div class="btn_box">
							<van-button class="btn" type="primary" color="#EF709E" block style="height: 72px;border-radius: 16px;" @click="goBuy(3)">Buy Now</van-button>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">Features and Benefits </div>
						<div class="msg_main">
							<div class="msg_el">
								<div>● Fast & Reliable Results: Get clear visual results in just 10 minutes.</div>
								<div>● Simple & Convenient: Available in strip, cassette, and consumer-friendly midstream formats to support a variety of testing needs.</div>
								<div>● Hormonal Transition Support: Supports women seeking greater insight into hormonal changes associated with menopausal transition.</div>
							</div>
						</div>
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">Performance</div>
						<div class="table_box">
							<el-table :data="tableData" border style="width: 100%">
								<el-table-column prop="data1" label="Performance Specification" align="center" width=''></el-table-column>
								<el-table-column prop="data2" label="Sample Type" align="center" width=''></el-table-column>
								<el-table-column prop="data3" label="Storage Temperature" align="center" width=''></el-table-column>
								<el-table-column prop="data4" label="Time to Result" align="center" width=''></el-table-column>
								<el-table-column prop="data5" label="Shelf Life" align="center" width=''></el-table-column>
							</el-table>
						</div>
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">How to Read Test Results</div>
						<div class="res_box">
							<div class="res_el bg1">
								<div class="left">
									<van-image width="auto" height="150px" :src="require('@/assets/FSH/5.webp')" />
								</div>
								<div class="right">
									<div class="tit">Positive Result</div>
									<div class="txt">
										Two colored bands are visible, and the test (T) band is equal to or darker than the control (C) band. This indicates FSH is present in the sample at or above the detection sensitivity of 25 mIU/mL.
									</div>
									<div class="txt">
										NOTE: A second test may be performed after 5 to 7 days to confirm the initial positive result. If the second result is also positive, it suggests that your normal FSH level has risen to a high level, which may indicate the beginning of the perimenopause (the transitional period leading up to menopause).
									</div>
								</div>
							</div>
							<div class="res_el bg2">
								<div class="left">
									<van-image width="auto" height="150px" :src="require('@/assets/FSH/6.webp')" />
								</div>
								<div class="right">
									<div class="tit">Negative Result</div>
									<div class="txt">
										Only one colored band appears in the control (C) region, or the test (T) band appears but is lighter than the control band. This indicates that the FSH concentration in the urine sample is below 25 mIU/mL.
									</div>
								</div>
							</div>
							<div class="res_el bg3">
								<div class="left">
									<van-image width="auto" height="150px" :src="require('@/assets/FSH/7.webp')" />
								</div>
								<div class="right">
									<div class="tit">Invalid Result</div>
									<div class="txt">
										If, at 10 minutes, no bands appear, or if a test (T) band appears without a control (C) band, the result is invalid. In this case, the test should be repeated using a new test device. If the problem persists, immediately discontinue using the test device and contact Technical Support.
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title" style="padding-top: 80px;">Want to Know More?</div>
						<div class="download_box">
							<div class="download_el">
								<div class="tit">1. Guide Download</div>
								<div class="txt" @click="downloadShow = true">
									<img src="../../assets/COT/download.webp" />&ensp;&ensp;<span>Download IFU</span>
								</div>
							</div>
							<div class="download_el">
								<div class="tit">2. Product Sale Sheet</div>
								<div class="txt" @click="downloadUrl('https://cordx.com/files/FSH/CorDx_Tyfast_FSH_Rapid_Test_Sale_Sheet.pdf')">
									<img src="../../assets/COT/download.webp" />&ensp;&ensp;<span>Download CorDx Tyfast FSH Rapid Test Sale Sheet</span>
								</div>
							</div>
						</div>
					</div>
					<div class="goTop"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						@click="goTop"
					>
						<img src="../../assets/COT/top.webp" />
						<div class="tit">BACK TO TOP</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<van-popup v-model="downloadShow" round closeable>
			<div class="download_popup">
				<div class="title">Guide Download</div>
				<div class="download_el" @click="downloadUrl('https://cordx.com/files/FSH/IFU_Strip_CorDx_Tyfast_FSH_Rapid_Test.pdf')">
					<span>IFU Strip CorDx Tyfast FSH Rapid Test</span>&ensp;&ensp;<img src="../../assets/COT/download.webp" />
				</div>
				<div class="download_el" @click="downloadUrl('https://cordx.com/files/FSH/IFU_Casstte_CorDx_Tyfast_FSH_Rapid_Test.pdf')">
					<span>IFU Casstte CorDx Tyfast FSH Rapid Test</span>&ensp;&ensp;<img src="../../assets/COT/download.webp" />
				</div>
				<div class="download_el" @click="downloadUrl('https://cordx.com/files/FSH/IFU_Midstream_CorDx_Tyfast_FSH_Rapid_Test.pdf')">
					<span>IFU Midstream CorDx Tyfast FSH Rapid Test</span>&ensp;&ensp;<img src="../../assets/COT/download.webp" />
				</div>
			</div>
		</van-popup>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { productInfo, productCount } from '@/api/public';
import md5 from 'js-md5';
import moment from 'moment';
import download from 'downloadjs';
export default {
	components:{
		navbar,
		footerBox,
		fixed
	},
	metaInfo() {
		return {
			meta: [
				{
					name: "description",
					content: this.metaDescription,
				},{
					name: "keywords",
					content: this.metaKeywords,
				}
			]
		}
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			metaDescription: '',
			metaKeywords: '',
			isAcitve: 1,
			downloadShow: false,
			tableData: [
				{
					data1: '25 mIU/mL',
					data2: 'Urine',
					data3: '2-30 C/ 36-86°F',
					data4: '10-20 minutes',
					data5: '24 months'
				}
			]
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//请求产品信息
		productInfo({
			custom: that.$route.name
		}).then(res => {
			that.infoData = res.data;
			document.title = res.data.title + ' - CorDx';
			that.metaDescription = res.data.description;
			that.metaKeywords = res.data.keywords;
			that.setOgTag('og:locale', 'en_US');
			that.setOgTag('og:title', res.data.title);
			that.setOgTag('og:description', res.data.description);
			that.setOgTag('og:image', res.data.url);
			that.setOgTag('og:image:width', '1200');
			that.setOgTag('og:image:height', '630');
			that.setOgTag('og:image:type', 'webp');
			that.isLoading = false;
			//统计访问
			let time = String(moment(new Date()).valueOf());
			setTimeout(() => {
				productCount({
					language: sessionStorage.getItem('lang') == 'en' ? 2 : 1,
					cate_id: that.infoData.cate_id,
					cert_id: that.infoData.cert_id,
					productid: that.infoData.id,
					url: that.$route.name,
					addtime: time,
					sign: md5(String(that.infoData.cate_id) + String(that.infoData.cert_id) + String(that.infoData.id) + that.$route.name + String(time) + 'CorDx2023'),
				}).then(res2 => {});
			}, 10000);
		});
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		downloadUrl(value) {
			let that = this;
			download(value);
		},
		//设置OG标签
		setOgTag(property, content) {
			const meta = document.querySelector(`meta[property='${property}']`);
			if(meta) {
				meta.setAttribute('content', content);
			} else {
				const newMeta = document.createElement('meta');
				newMeta.setAttribute('property', property);
				newMeta.setAttribute('content', content);
				document.head.appendChild(newMeta);
			}
		},
		goBuy(value) {
			switch(value) {
				case 1:
					window.open('https://al21.com/products/cordx-tyfast-fsh-rapid-test-strip?_pos=20&_sid=c197c5b63&_ss=r');
				break;
				case 2:
					window.open('https://al21.com/products/cordx-tyfast-fsh-rapid-test-cassette-10-tests-box?open_in_browser=true');
				break;
				case 3:
					window.open('https://al21.com/products/cordx-tyfast-fsh-rapid-test-midstream-3-tests-box?_pos=18&_sid=c197c5b63&_ss=r');
				break;
			}
		},
		checkActive(value) {
			this.isAcitve = value;
		},
		goTop() {
			window.scrollTo({ top: 0, behavior: 'smooth' })
		},
	}
}
</script>

<style scoped lang="less">
.download_popup{
	padding: 50px;
	.download_el{
		img{
			width: 35px;
		}
		span{
			display: inline-block;
			font-weight: bold;
			font-size: 20px;
			padding-top: 6px;
		}
		margin-bottom: 24px;
		cursor: pointer;
	}
	.title{
		padding-bottom: 32px;
		font-weight: bold;
		font-size: 32px;
	}
}
.main_box{
	//块2
	.block_2{
		.block_2_main{
			width: 1300px;
			margin: 0 auto;
			.goTop{
				.tit{
					padding-top: 20px;
					font-weight: bold;
					font-size: 48px;
					color: #18318E;
				}
				img{
					width: 80px;
				}
				padding: 120px 0 150px 0;
				text-align: center;
				cursor: pointer;
			}
			.msg_box{
				width: 100%;
				.download_box{
					padding: 50px 50px 20px 50px;
					border-radius: 24px 24px 24px 24px;
					border: 1px solid #999999;
					.download_el{
						.txt{
							span{
								display: inline-block;
								padding-top: 4px;
								font-size: 24px;
							}
							img{
								width: 35px;
							}
							padding-bottom: 30px;
							cursor: pointer;
						}
						.tit{
							padding-bottom: 5px;
							font-weight: bold;
							font-size: 42px;
						}
					}
				}
				.res_box{
					.bg3{
						background: #FFF7EC;
						border: 2px solid #FFD6A7;
					}
					.bg2{
						background: #EEF5FE;
						border: 2px solid #FFC9C9;
					}
					.bg1{
						background: #EEF5FE;
						border: 2px solid #B8F7CF;
					}
					.res_el{
						display: flex;
						align-items: center;
						margin-bottom: 40px;
						padding: 50px;
						border-radius: 24px 24px 24px 24px;
						.right{
							flex: 1;
							padding-left: 40px;
							.tit{
								font-size: 36px;
								font-weight: bold;
							}
							.txt{
								padding: 5px 0;
								font-size: 24px;
							}
						}
						.left{
							width: 155px;
						}
					}
				}
				.msg_main2{
					padding: 50px 60px;
					border-radius: 24px 24px 24px 24px;
					border: 1px solid #999999;
					.tit{
						font-size: 24px;
					}
					.msg_el2{
						padding-top: 40px;
						.msg_el2_main{
							display: flex;
							.left{
								flex: 1;
								font-weight: bold;
								font-size: 24px;
								padding-right: 20px;
								padding-top: 10px;
							}
							.right{
								flex: 1;
								padding-left: 20px;
							}
						}
						.msg_el2_tit{
							font-weight: bold;
							font-size: 42px;
						}
					}
				}
				.msg_main{
					.msg_el{
						flex: 1;
						line-height: 1.8;
						div{
							font-size: 24px;
						}
					}
					display: flex;
					padding: 50px 60px;
					border-radius: 24px 24px 24px 24px;
					border: 1px solid #999999;
				}
				.title{
					padding: 120px 0 40px 0;
					font-weight: bold;
					font-size: 48px;
					text-align: center;
				}
			}
		}
	}
	//块1
	.block_1{
		.block_1_main{
			width: 1300px;
			display: flex;
			margin: 0 auto;
			padding: 100px 0 0px 0;
			.product_el{
				.btn_box{
					padding: 0 50px 50px 50px;
					position: absolute;
					left: 0;
					bottom: 0;
					width: 100%;
					.btn{
						width: 100%;
						.van-button__text{
							font-size: 24px;
						}
					}
				}
				.txt_box{
					.txt_el{
						font-size: 24px;
						font-weight: bold;
						line-height: 1.8;
					}
					padding-bottom: 110px;
				}
				.tag_box{
					.active{
						border: 1px solid #1347E5 !important;
						background: #EEF5FE !important;
						color: #1347E5 !important;
					}
					.tag_el{
						flex: 1;
						padding: 20px 0 15px 0;
						text-align: center;
						font-size: 24px;
						border-radius: 16px 16px 16px 16px;
						border: 1px solid #999999;
						cursor: pointer;
					}
					.mar_l{
						margin-left: 10px;
					}
					.mar_r{
						margin-right: 10px;
					}
					display: flex;
					padding: 10px 0 25px 0;
				}
				.txt{
					font-size: 20px;
					color: #666666;
				}
				.tit{
					padding: 20px 0 16px 0;
					font-size: 30px;
					font-weight: bold;
				}
				.tips{
					position: absolute;
					top: 0;
					width: auto;
					left: 0;
					padding: 10px 18px;
					background: #EF709E;
					border-radius: 24px 0px 24px 0px;
					font-size: 20px;
					color: #ffffff;
				}
				flex: 1;
				position: relative;
				padding: 70px 30px 50px 30px;
				border: 1px solid #999999;
				border-radius: 24px;
				overflow: hidden;
			}
			.mar_r{
				margin-right: 30px;
			}
			.mar_l{
				margin-left: 30px;
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		img{
			width: 100%;
			min-width: 1300px;
		}
	}
	//引导块
	.tips_box{
		padding: 50px 0 30px 0;
		background: linear-gradient(to right, #F2F7FD, transparent);
		.tips_main{
			width: 1140px;
			margin: 0 auto;
			font-size: 18px;
			span{
				color: #0B318F;
				font-size: 18px;
			}
		}
	}
	.icon{
		position: absolute;
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .block_1_box p{
	margin: 0;
}
>>> .block_5 .el-collapse{
	border: none;
	/* border-bottom: 1px solid #999999; */
}
>>> .block_5 .van-collapse-item{
	border-bottom: 1px solid #999999;
}
>>> .block_5 .van-cell{
	padding: 0;
	line-height: normal;
}
>>> .block_5 .van-collapse-item__content{
	padding: 0;
}
>>> .table_box .el-table .cell{
	color: #000000;
	font-size: 20px;
}
>>> .table .el-table th.el-table__cell{
	font-weight: bold;
}
>>> .table_box .el-table .el-table__cell{
	padding: 24px 0;
}
</style>